import React,{createContext,useContext,useState,useEffect,useCallback} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import config from "../config";

const LS_TOKEN="api_jwt";const LS_EXP="api_jwt_exp";
const ApiContext=createContext();
export const useApi=()=>useContext(ApiContext);
let ongoing=null;             // verrou partagé

export function ApiAuthProvider({children}){
    const {isAuthenticated,isLoading,getAccessTokenSilently,logout}=useAuth0();
    const [apiToken,setApiToken]=useState(()=>localStorage.getItem(LS_TOKEN));
    const [expMs,setExpMs]=useState(()=>Number(localStorage.getItem(LS_EXP))||null);

    const saveToken=(t,e)=>{
        if(t&&e){localStorage.setItem(LS_TOKEN,t);localStorage.setItem(LS_EXP,String(e))}
        else{localStorage.removeItem(LS_TOKEN);localStorage.removeItem(LS_EXP)}
        setApiToken(t);setExpMs(e);
    };

    const exchangeToken=useCallback(async()=>{
        if(ongoing)return ongoing;
        ongoing=(async()=>{
            const auth0Token=await getAccessTokenSilently();
            const res=await fetch(`${config.API_URL}/exchange-token`,{
                method:"POST",headers:{"Content-Type":"application/json"},
                body:JSON.stringify({token:auth0Token})
            });
            if(!res.ok)throw new Error(`Échange refusé (${res.status})`);
            const json=await res.json();
            const token=json.token??json.data?.token;
            if(!token)throw new Error("Token manquant");
            const {exp}=JSON.parse(atob(token.split(".")[1]));
            saveToken(token,exp*1000);
            return token;
        })().catch(e=>{console.error(e);logout({logoutParams:{returnTo:window.location.origin}});throw e})
            .finally(()=>ongoing=null);
        return ongoing;
    },[getAccessTokenSilently,logout]);

    const ensureFresh=useCallback(async()=>{
        const now=Date.now();
        if(!apiToken||!expMs||now>expMs-120000)return await exchangeToken();
        return apiToken;
    },[apiToken,expMs,exchangeToken]);

    const apiFetch=useCallback(async(path,opts={})=>{
        let token=await ensureFresh();
        const doReq=tk=>fetch(`${config.API_URL}${path}`,{...opts,headers:{...(opts.headers||{}),Authorization:`Bearer ${tk}`}});
        let res=await doReq(token);
        if(res.status===401){
            token=await exchangeToken();
            res=await doReq(token);
            if(res.status===401)logout({logoutParams:{returnTo:window.location.origin}});
        }
        return res;
    },[ensureFresh,exchangeToken,logout]);

    useEffect(()=>{
        if(isLoading)return;
        if(isAuthenticated){
            const now=Date.now();
            if(!apiToken||!expMs||now>expMs-120000)exchangeToken();
        }else saveToken(null,null);
    },[isLoading,isAuthenticated,exchangeToken,apiToken,expMs]);

    return <ApiContext.Provider value={{apiFetch,apiToken}}>{children}</ApiContext.Provider>;
}
